var _excluded = ["max", "min", "className"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { useField } from 'formik';
import { formatCurrency } from '@futurefamily/ef-utils';
var Wrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  position: relative;\n  margin-bottom: 20px;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  user-select: none;\n"])));

var slider = function slider(props) {
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  width: var(--slider-thumb-diameter, 24px);\n  height: var(--slider-thumb-diameter, 24px);\n  background: var(--slider-thumb-color);\n  border-radius: 50%;\n  cursor: pointer;\n"])));
};

var Range = styled.input.attrs({
  type: 'range'
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  display: block;\n  width: 100%;\n  height: var(--slider-track-height, 12px);\n  margin-bottom: 8px;\n  appearance: none;\n  outline: none;\n  background-color: transparent;\n\n  &::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    ", "\n  }\n\n  &::-moz-range-thumb {\n    ", "\n  }\n\n  &::-ms-thumb {\n    ", "\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n"])), slider, slider, slider);
var Track = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n  height: var(--slider-track-height, 12px);\n  background-color: var(--slider-track-color);\n  margin-bottom: 10px;\n"])));
var Amount = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n  position: absolute;\n  font-size: 0.9rem;\n  font-weight: 500;\n  color: var(--slider-text-color, var(--gray));\n"])));

var Slider = function Slider(_ref) {
  var max = _ref.max,
      _ref$min = _ref.min,
      min = _ref$min === void 0 ? 0 : _ref$min,
      className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var _useField = useField(_extends({
    type: 'range',
    min: min,
    max: max
  }, props)),
      field = _useField[0],
      meta = _useField[1],
      helpers = _useField[2];

  useEffect(function () {
    if (meta.value > max) {
      helpers.setValue(max);
    }
  }, [max, meta.value, helpers]);
  var midPoint = (Number(max) + Number(min)) / 2;
  return /*#__PURE__*/React.createElement(Wrapper, {
    className: className
  }, /*#__PURE__*/React.createElement(Track, null, /*#__PURE__*/React.createElement(Range, _extends({}, props, {
    max: max,
    min: min
  }, field))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Amount, null, "$", formatCurrency(min)), /*#__PURE__*/React.createElement(Amount, {
    style: {
      left: '50%',
      transform: 'translateX(-50%)'
    }
  }, "$", formatCurrency(midPoint)), /*#__PURE__*/React.createElement(Amount, {
    style: {
      left: '100%',
      transform: 'translateX(-100%)'
    }
  }, "$", formatCurrency(max))));
};

Slider.propTypes = process.env.NODE_ENV !== "production" ? {
  className: PropTypes.string,
  max: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  min: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
export default Slider;